/**
 * Wrapper for QuickCreateMenu that launches the outbound stock movement wizard.
 */
import { StockMovementWizard } from '../../modules/inventory/components/StockMovementWizard';

interface Props {
  open: boolean;
  onClose: () => void;
}

export function QuickCreateStockIssueForm({ open, onClose }: Props) {
  return <StockMovementWizard open={open} onClose={onClose} direction="outbound" />;
}
